export interface CameraFeelTuning {
  tauChase: number;
  tauCockpit: number;
  tauFrameChase: number;
  tauFrameCockpit: number;
}

export interface FlightFeelTuning {
  speedFov: number;
  boostFov: number;
  thrustShake: number;
  boostShake: number;
  speedShake: number;
  combatShake: number;
  shakePosKm: number;
}

export interface FeelTuningDefaults {
  camera: CameraFeelTuning;
  flight: FlightFeelTuning;
}

export const FEEL_TUNING_DEFAULTS: Readonly<FeelTuningDefaults> = {
  camera: {
    tauChase: 0.04,
    tauCockpit: 0.03,
    tauFrameChase: 1.0,
    tauFrameCockpit: 0.12,
  },
  flight: {
    speedFov: 8,
    boostFov: 12,
    thrustShake: 0.0009,
    boostShake: 0.003,
    speedShake: 0.0008,
    combatShake: 0.012,
    shakePosKm: 9,
  },
};

export const createCameraFeelTuning = (): CameraFeelTuning => ({
  ...FEEL_TUNING_DEFAULTS.camera,
});

export const createFlightFeelTuning = (): FlightFeelTuning => ({
  ...FEEL_TUNING_DEFAULTS.flight,
});

export const setCameraFeelTuning = (
  tuning: CameraFeelTuning,
  key: keyof CameraFeelTuning,
  value: number,
): void => {
  tuning[key] = value;
};

export const setFlightFeelTuning = (
  tuning: FlightFeelTuning,
  key: keyof FlightFeelTuning,
  value: number,
): void => {
  tuning[key] = value;
};
